import {
  LuggageIcon,
  VenusIcon,
  MarsIcon,
  GemIcon,
  BabyIcon,
  HeartPulse,
  SproutIcon,
  DumbbellIcon,
  HelpCircle,
  CableIcon,
  type LucideIcon,
} from 'lucide-react';

export const CATEGORIES = {
  'rts.womensFashion': {
    name: 'DS_CATEGORY_WOMENS_FASHION',
    Icon: VenusIcon,
    templateId: '25529185-9805-4bfe-9721-0e0e55b7eafd',
    color: '#FF69B4',
  },
  'rts.mensFashion': {
    name: 'DS_CATEGORY_MENS_FASHION',
    Icon: MarsIcon,
    templateId: 'fae66f4e-4fe8-4ae5-8cb1-d038728c1ace',
    color: '#4169E1',
  },
  'rts.jewelryAccessories': {
    name: 'DS_CATEGORY_JEWELRY_ACCESSORIES',
    Icon: GemIcon,
    templateId: '29ffdf7e-b9e7-4143-bea9-8d95755583e1',
    color: '#FFC700',
  },
  'rts.kidsBabies': {
    name: 'DS_CATEGORY_KIDS_BABIES',
    Icon: BabyIcon,
    templateId: '7528333c-96c8-45da-a4ff-5d19e334b4af',
    color: '#00AA8D',
  },
  'rts.beautyHealth': {
    name: 'DS_CATEGORY_BEAUTY_HEALTH',
    Icon: HeartPulse,
    templateId: '9b8cfd1c-c099-40c5-8ea9-c87fa30f99a1',
    color: '#FF6B6B',
  },
  'rts.homeGarden': {
    name: 'DS_CATEGORY_HOME_GARDEN',
    Icon: SproutIcon,
    templateId: 'da7dd4f7-54cf-47a7-8752-b76f99e439b6',
    color: '#00D200',
  },
  'rts.sportsEntertainment': {
    name: 'DS_CATEGORY_SPORTS_ENTERTAINMENT',
    Icon: DumbbellIcon,
    templateId: '8fc69242-47c2-4bd3-aedd-2fdea4e2c2a6',
    color: '#4682B4',
    // color: '#8700DD',
  },
  'rts.bagsLuggage': {
    name: 'DS_CATEGORY_BAGS_LUGGAGE',
    Icon: LuggageIcon,
    templateId: '8ccb4934-0cda-48a1-bed8-4d2b3ab617a7',
    color: '#DEB887',
  },
  'rts.consumerElectronics': {
    name: 'DS_CATEGORY_CONSUMER_ELECTRONICS',
    Icon: CableIcon,
    templateId: '4052c015-c49c-4656-a5d3-aee3929c9156',
    color: '#461bac',
  },
  'rts.chooseForMe': {
    name: 'DS_CATEGORY_CHOOSE_FOR_ME',
    Icon: HelpCircle,
    templateId: '',
    color: '#808080',
  },
} as const satisfies Record<string, { name: string; Icon: LucideIcon; templateId: string; color: string }>;

export type CategoryKey = keyof typeof CATEGORIES;

export const RANDOM_CATEGORY: CategoryKey = 'rts.chooseForMe';

export const getRandomCategory = (): CategoryKey => {
  const categoryKeys = Object.keys(CATEGORIES).filter((key) => key !== RANDOM_CATEGORY);
  const randomIndex = Math.floor(Math.random() * categoryKeys.length);
  return categoryKeys[randomIndex] as CategoryKey;
};

export const getTemplateIdForCategory = (category: CategoryKey): string => {
  return CATEGORIES[category].templateId;
};

export const CATEGORIES_WITHOUT_COMPONENT_UPDATE = [
  'rts.womensFashion',
  'rts.mensFashion',
  'rts.kidsBabies',
  'rts.homeGarden',
  'rts.beautyHealth',
  'rts.sportsEntertainment',
  'rts.consumerElectronics',
  'rts.jewelryAccessories',
];
